import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import {
  Box,
  Button,
  ButtonBar,
  HorizontalFormControl,
} from '../../../../../common/components';
import { connect } from 'react-redux';

import { actions } from '../../../redux/ProductReducer';

const AdminFeesForm = ({ submitting, reset, onUpdate, handleSubmit, onCancel }) => {
  const cancel = () => {
    reset();
    onCancel();
  };

  const update = (values) => {
    reset();
    onUpdate(values);
  };

  return (
    <Form onSubmit={handleSubmit(update)}>
      <Box className="product-container scheme-container margin-bottom animated fadeIn">
        <hr />
        {/*<div className="div">*/}
        <Row className="section-item">
          <Col sm={6}>
            <Field
              label="Name"
              labelSize={4}
              name="data.attributes.name"
              component={HorizontalFormControl}
            />
          </Col>
        </Row>

        <ButtonBar>
          <Button
            type={'submit'}
            bsStyle="primary"
            isLoading={submitting}
            className="pull-right pad-right"
          >
            Save
          </Button>

          <Button bsStyle="default" handleClick={cancel}>
            Cancel
          </Button>
        </ButtonBar>
      </Box>
    </Form>
  );
};

const FORM_NAME = 'AdminFeesDetailsForm';
const form = reduxForm({ form: 'AdminFeesDetailsForm' })(AdminFeesForm);

export default connect(
  (state, props) => {
    return {
      initialValues: {
        data: {
          id: props.feeScheme.id,
          attributes: {
            name: props.feeScheme.attributes.name,
            from_date: '',
            to_date: '',
          },
        },
      },
      formValues: getFormValues(FORM_NAME)(state),
    };
  },
  {
    adminFeeImportRates: actions.adminFeeImportRates,
    adminFeeEditRates: actions.adminFeeEditRates,
  },
)(form);
